var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"social-icons"},_vm._l((_vm.socials),function(link){return _c('a',{key:link.name,class:_vm.socialLinkClassModifiers(link),attrs:{"href":link.href,"target":"_blank"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }